/**
 * Tags Formatter.
 * @param {*} value
 * @returns {String}
 */
window.tagsFormatter = function(value) {
    let html = '';
    if (value === null) {
        return html;
    }
    let a = value.split(",");
    for (let i = 0; i < a.length; i++) {
        html += '<span class="badge badge-pill badge-tags" style="margin-right: 6px">'+a[i]+'</span>';
    }
    return html;
};
